import { createQueryHook } from "@accurx/api/QueryClient";
import { NhsOrganisationsSearchResponse } from "@accurx/api/account";
import { httpClient2 } from "@accurx/shared";

export const SEARCH_MAPPING_ORGANISATIONS = "GetMappingOrganisations";

export const useSearchMappingOrganisationsQuery = createQueryHook(
    ({
        workspaceId,
        searchTerm,
        page = 1,
        limit = 20,
    }: {
        workspaceId: number;
        searchTerm: string;
        page?: number;
        limit?: number;
    }) => ({
        queryKey: [
            SEARCH_MAPPING_ORGANISATIONS,
            { workspaceId, searchTerm, page, limit },
        ],
        queryFn: async () => {
            const response = await httpClient2
                .get({
                    path: `/api/account/WorkspaceMapping/search?organisationId=${workspaceId}&searchTerm=${searchTerm}&limit=${limit}&page=${page}`,
                })
                .json<NhsOrganisationsSearchResponse>();

            return response;
        },
        enabled: Boolean(searchTerm),
        staleTime: 5 * 60 * 1000,
    }),
);
